module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reservationDetails"
  }, [_c('x-header', {
    staticClass: "zdyheaderBlue",
    attrs: {
      "left-options": {
        showBack: true
      }
    }
  }, [_vm._v(_vm._s(_vm.headerName))]), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "5em"
    }
  }, [_c('cell', {
    attrs: {
      "title": "项目名称",
      "primary": "content",
      "value": _vm.paramsData.orderName
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "执行科室",
      "value": _vm.paramsData.execDeptName
    }
  }), _vm._v(" "), (_vm.orderno) ? _c('cell', {
    attrs: {
      "title": "开单医生",
      "value": _vm.paramsData.reqDoctorName
    }
  }) : _vm._e(), _vm._v(" "), (_vm.orderno) ? _c('cell', {
    attrs: {
      "title": "开单时间",
      "value": _vm.paramsData.reqDate
    }
  }) : _vm._e(), _vm._v(" "), (_vm.orderno) ? _c('cell', {
    attrs: {
      "title": "申请单号",
      "value": _vm.paramsData.bsuperOrderID
    }
  }) : _vm._e(), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "预约日期",
      "is-link": "",
      "value": _vm.dateTxt
    },
    nativeOn: {
      "click": function($event) {
        _vm.dateChange($event)
      }
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "预约时段",
      "is-link": "",
      "value": _vm.timeTxt
    },
    nativeOn: {
      "click": function($event) {
        _vm.dateChange($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "30px 10px 0"
    }
  }, [_c('x-button', {
    staticClass: "orangeBtn",
    staticStyle: {
      "border-radius": "25px"
    },
    attrs: {
      "disabled": _vm.sureDisable
    },
    nativeOn: {
      "click": function($event) {
        _vm.sureClick($event)
      }
    }
  }, [_vm._v("确 认")])], 1), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "mask-time",
    staticStyle: {
      "display": "none"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "time-area",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "time-choose-table font13 txt-gray",
    attrs: {
      "id": "time-choose-table"
    }
  }), _vm._v(" "), _c('x-button', {
    staticClass: "am-btn btn-default am-btn-green mt-line btn-choose-time",
    staticStyle: {
      "width": "94.668%",
      "margin-top": "0px"
    }
  }, [_vm._v("确定选择")])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "softlyFragrant"
  }, [_c('h3', [_vm._v("温馨提示:")]), _vm._v(" "), _c('p', {
    staticClass: "dectionP"
  }, [_vm._v("\n     1.若不能按时到院可修改预约时间"), _c('br'), _vm._v("\n     2.提前1小时内取消后只能到院预约"), _c('br'), _vm._v("\n     3.连续3次爽约则取消在线预约资格3个月")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-date"
  }, [_c('ul', {
    staticClass: "promptu-menu2 font13"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13263bff","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/MyReservationProject/reservationDetails.vue
// module id = O39O
// module chunks = 6